import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 21);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-95" data-mp="20slh2v74j9qj">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-96" data-mp="3h7ecgazha2gm">
        <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="3h5tjgpstarkv">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-98" data-mp="3c8tdsfzvjqua">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-99" data-mp="3vynl4myo2bem">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-100" data-mp="9si87x0pwf0m" data-mpi={index}>
                <div data-id="element-101" data-mp="9tjwx4anp00t">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-102" data-mp="9t0apbdz3pgz">
                    {value}
                  </p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-103" data-mp="3d97dlfokdiop">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-104" data-mp="3i8bocar4zoh5">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-105" data-mp="3ryn5x03qtw6i">
            Después sube. <b className="text-white" data-id="element-106" data-mp="2uipp5narl995">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-107" data-mp="2ugdbhmc1hl1w">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-108" data-mp="2zf7twn63h7lh">
              <span data-id="element-109" data-mp="2res0i3enaqwc">Cupos al precio de lanzamiento</span>
              <span data-id="element-110" data-mp="2mijnownx79sc">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-111" data-mp="2mfxi32klb4cr">
              <div className="h-full w-[72%] rounded-full bg-red-500" data-id="element-112" data-mp="318qzitjf9uk2" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-113" data-mp="2w8d205fg630a">
              72% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-114" data-mp="23jpdm0zeixii">
        <div className="mx-auto max-w-2xl" data-id="element-115" data-mp="23l0g7xh41z81">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-116" data-mp="2igpvlcrsje3s">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-117" data-mp="2dfikp4ucpysw">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-118" data-mp="92geodw4hqu">
              <div data-id="element-119" data-mp="5a9nel87lcwg">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-120" data-mp="5aruye0bndjo">
                  🌿 SISTEMA COOPERACIÓN SIN CONFLICTOS™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-121" data-mp="3rfwwnth61ssi">
                  3 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-122" data-mp="j1n4lsin9yob">
                  Tu sistema completo en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-123" data-mp="a7s10ox68gas">
                <p className="text-xs uppercase tracking-wider text-slate-500" data-id="element-124" data-mp="e9wthkbvv6vu">
                  Precio original
                </p>
                <p className="text-slate-500 line-through" data-id="element-125" data-mp="11yob5hruk6ud">$65.000 ARS</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-brand-light/70" data-id="element-126" data-mp="16qzeyvppkcs7">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-127" data-mp="3f8tn64b4kydk">
                  $19.990
                </p>
                <p className="text-xs text-slate-400" data-id="element-128" data-mp="359cjttjciwkr">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-129" data-mp="31894d857n2k2">
            QUIERO MI SISTEMA AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}